import React from 'react';

import {
  SearchResult,
} from '../../../components';

import MemberTeaser from './Teaser';
import MemberFull from './Full';

const Member = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<MemberTeaser entity={entity} {...props} />);
    default:
      return (<MemberFull entity={entity} {...props} />);
  }
};

export default Member;
